import { Button } from '@framework/ui/atoms/Button';
import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { useCallback, useState } from 'react';

type Props = {
  isOpen: boolean;
  onSubmit(): Promise<void>;
  onClose(): void;
};

export const StopMailRequestConfirmModal: React.FC<Props> = ({ isOpen, onSubmit, onClose }: Props) => {
  const [isProcessing, setIsProcessing] = useState<boolean>(false);

  const handleSubmit = useCallback(async () => {
    setIsProcessing(true);

    await onSubmit();

    setIsProcessing(false);
    onClose();
  }, [onClose, onSubmit]);

  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <GeneralModal
      isOpen={isOpen}
      onClose={handleClose}
      title={'配信停止します'}
      submitButton={
        <Button color="danger" onClick={handleSubmit} loading={isProcessing}>
          配信停止
        </Button>
      }
      cancelButton={
        <Button onClick={handleClose} color="secondary" loading={isProcessing}>
          キャンセル
        </Button>
      }
    >
      <div className="p-2">
        <div>
          翌日以降に配信予定のオンボーディング・メールが停止されます。
          <br />
          配信停止してよろしいですか？
        </div>
      </div>
    </GeneralModal>
  );
};
